let urlEncodeFilter = angular.module("common.filters.urlEncode", []);
urlEncodeFilter.filter('urlEncode', function() {
    return window.encodeURIComponent;
});